module.exports = __webpack_public_path__ + "img/xsj_log1-4.ceb74398.png";